import identity from 'ramda/src/identity'
import createProjectDrop from 'root/src/client/logic/project/thunks/createProjectDrop'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import { INITIAL_KEY_SELECTION_MODULE_ID, INITIAL_PRODUCT_DISPLAY_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { CHECK_USER_HAS_GAME } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getUserDropEventLandingShortUrl } from 'root/src/client/logic/dropEvent/thunks/getUserDropEventLandingShortUrl'

export default (formData, props) => async (dispatch, getState) => {
	const { dropEvent } = formData
	const { id: campaignId, initialProduct, brand: { id: brandId }, isGameFree } = dropEvent
	const { body: userHasKey } = await dispatch(
		apiRequest(CHECK_USER_HAS_GAME, { brandId, campaignId }),
	)
	if (!userHasKey) {
		if (initialProduct?.length) {
			return dispatch(displayModal(INITIAL_KEY_SELECTION_MODULE_ID, { payload: formData, props }))
		}
	}

	const showModalFn = async () => {
		if (userHasKey && (isGameFree || !initialProduct)) {
			const shortUrl = await getUserDropEventLandingShortUrl(dropEvent.id)(dispatch, getState)
			return dispatch(displayModal(INITIAL_PRODUCT_DISPLAY_MODAL_MODULE_ID, {
				...props,
				...formData,
				shortUrl,
				isCloseable: false,
			}))
		}

		return identity
	}

	return dispatch(createProjectDrop(formData, showModalFn))
}
